// @flow
import React from 'react';
import { useFormikContext } from 'formik';
import styled from 'styled-components';
import { getDimensionFieldPathForEstimateCC } from '@components/committed-capacity/utils';
import { Spacer } from '@presentational/spacing/Spacer';

import { TextField } from '../../../formik-utils/FormFields';
import { TEXT_NUMBER_INPUT_TYPE } from '../../../formik-utils/consts';
import { IS_ROW_OPENED_FOR_EDITING } from '../../../constants';
import { useIsRowInputDisabledForEstimateCC } from '../../../custom-hooks/useIsRowInputDisabledForEstimateCC';
import { ESTIMATE_COMMITTED_CAPACITY } from '../enums';
import { formatCurrency0DP } from '../../views/grid-utils/renderers';
import { calculateListPrice } from '../../../common-utils/utils';

const StyledListPrice = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 4px;
`;

const getDSPSPListAmount = (dimensionRow) => {
  const discountedDSPSPAmount =
    dimensionRow[ESTIMATE_COMMITTED_CAPACITY.QUANTITY_BACKEND_FIELD_NAME];

  const discount = dimensionRow[ESTIMATE_COMMITTED_CAPACITY.DISCOUNT_BACKEND_FIELD_NAME];

  return calculateListPrice(discountedDSPSPAmount, discount);
};
export const DiscountedDSPSPPriceContainerForEstimateCC = ({
  dimensionRow,
  metricRow,
  configuredMetrics,
  metricIndex,
  dimensionIndex,
}) => {
  const { setFieldValue } = useFormikContext();

  const shouldBeDisabled = useIsRowInputDisabledForEstimateCC({
    dimensionRow,
    metricName: metricRow.metricName,
    configuredMetrics,
  });

  const discountedPricePath = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    ESTIMATE_COMMITTED_CAPACITY.QUANTITY_BACKEND_FIELD_NAME
  );

  const inProgressFieldName = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    IS_ROW_OPENED_FOR_EDITING
  );

  const dspSPListAmount = getDSPSPListAmount(dimensionRow);

  return (
    <>
      <TextField
        addLabel={false}
        disableOnFormErrors={false}
        disabled={shouldBeDisabled}
        fieldDisplayName={ESTIMATE_COMMITTED_CAPACITY.DSP_SP_COMMITMENT_AMOUNT_DISPLAY_NAME}
        fieldName={discountedPricePath}
        onChange={async () => {
          await setFieldValue(inProgressFieldName, true);
        }}
        placeholder={ESTIMATE_COMMITTED_CAPACITY.DSP_SP_COMMITMENT_AMOUNT_DISPLAY_NAME}
        type={TEXT_NUMBER_INPUT_TYPE}
      />
      <StyledListPrice>
        Amount at List:
        <Spacer x={5} />
        {dspSPListAmount != null ? formatCurrency0DP.format(dspSPListAmount) : '-'}
      </StyledListPrice>
    </>
  );
};
